<template>
  <PanelHeading
    :title="lc.title"
    :description="lc.description"
    header
    headerColor="primary"
    wave
  >
    <template #subtitle>
      {{ lc.welcome }}, <b>{{ username }}</b>
    </template>
  </PanelHeading>
</template>
<script>
import PanelHeading from '@/components/PanelHeading.vue'

export default {
  name: 'SitesHeading',
  components: {
    PanelHeading
  },
  props: {
    username: {
      type: String,
      required: true
    }
  },
  computed: {
    lc () {
      return this.$lc('site.components.sitesHeading')
    }
  }
}
</script>
